export default __webpack_public_path__ + "static/media/10.782d62bd.png";